/* eslint-disable max-len */
import { toMoment } from 'utils/normalizers';
import { selectConfiguracionEntidad } from 'store/auth';
import store from 'store/store';
import { getDiasInhabiles } from '../api/catalogos';

export const DATE_FORMAT = 'DD-MM-YYYY';
export const DATE_NETPAY_FORMAT = 'YYYY/MM/DD';

const disabledDays = async (periodo_fiscal, fecha_de_vencimiento) => {
  // Obtener los días inhabiles
  const request = await getDiasInhabiles({ periodo_fiscal });
  if (!request || !Array.isArray(request)) {
    throw new Error('No se pudo obtener los días inhábiles');
  }
  const daysDisabled = request.map((e) => toMoment(e.fecha).format('YYYY-MM-DD'));
  const fechaVencimiento = toMoment(fecha_de_vencimiento);

  let fechaVencimientoFinal = fechaVencimiento;

  // Si la fecha de vencimiento es domingo o sabado, se pasa al siguiente día hábil.
  while (
    daysDisabled.includes(fechaVencimientoFinal.format('YYYY-MM-DD'))
    || fechaVencimientoFinal.day() === 0
    || fechaVencimientoFinal.day() === 6
  ) {
    fechaVencimientoFinal = fechaVencimientoFinal.add(1, 'days');
  }

  // Si la fecha de vencimiento final es igual a la fecha de vencimiento, se pasa al siguiente día hábil.
  if (fechaVencimientoFinal.isSame(fechaVencimiento)) {
    fechaVencimientoFinal = fechaVencimientoFinal.add(1, 'days');
  }

  return fechaVencimientoFinal.format(DATE_NETPAY_FORMAT || 'YYYY-MM-DD');
};

const exclusiveExpiryDate = ({ type, periodoFiscal }) => {
  if (type === 'inpc') {
    const entidadInfo = selectConfiguracionEntidad(store.getState());
    const INPC = entidadInfo?.dia_de_mes_para_actualizacion_inpc || 0; // es 10
    const INPC_DATE = toMoment(new Date()).set('date', INPC);
    return disabledDays(periodoFiscal, INPC_DATE.format(DATE_NETPAY_FORMAT));
  }

  throw new Error('Tipo de vencimiento no encontrado');
};

export const calculateExpiryDateDeclaraciones = async ({
  cargos,
  allowInpc = false,
  periodoFiscal,
  lastState,
}) => {
  let fechaVencimiento = null;

  // Fecha de vigencia del cargo padre.
  const expDay = toMoment(cargos.find((c) => c?.tipo_de_cargo?.fecha_de_vencimiento)
    ?.tipo_de_cargo?.fecha_de_vencimiento) || null;

  // Recursos
  const currentDate = toMoment(new Date()); // Fecha actual.
  const lastDay = toMoment(lastState).endOf('month'); // Ultimo dia del mes.
  const isTwoDaysLastMonth = expDay.isSame(lastDay, 'day') - 1; // ultimo o penultimo dia del mes.
  const day = toMoment(expDay).date() || 10; // Fecha de vencimiento del cargo.
  const dayExp = lastState.get('date'); // dia de expedición del cargo.

  // Condiciones
  const mismoMes = currentDate.isSame(lastState, 'month'); // Verificar si están en el mismo mes.
  const isBeforeExpiryDay = (dayExp < day) && mismoMes; // Verificar si el día de expedición es antes del día de vencimiento.

  // Función para dar formato a la fecha de vencimiento.
  const exp = (_expiryDate) => toMoment(_expiryDate).format(DATE_NETPAY_FORMAT);

  // Excepciones de vencimiento.
  // 1.- Si el cargo es INPC, la fecha de vencimiento es el día 10 de cada mes.
  if (allowInpc) return exclusiveExpiryDate({ type: 'inpc', periodoFiscal });

  // Condiciones
  // 1.- No tiene vencimiento y hoy es antes del último dia del mes, resultado: último dia del mes.
  // 2.- Hoy es igual a la fecha de vencimiento, resultado: se le suma un dia.
  // 3.- Hoy es último o penultimo dia del mes, resultado: dia de vencimiento pero mes siguiente.
  // 4.- Hoy es antes de vencimiento, resultado: fecha de vencimiento.
  // 5.- Hoy es despues de vencimiento y antes del dia (day), resultado: dia (day).
  // 6.- Hoy es despues de vencimiento y despues del dia (day), resultado: último dia del mes.
  // 7.- No cumple con ninguna condición, resultado: final del mes siguiente.
  if (!expDay && lastState.isBefore(lastDay)) {
    fechaVencimiento = await disabledDays(periodoFiscal, exp(lastDay));
  }
  if ((expDay).isSame(lastState, 'day')) {
    fechaVencimiento = await disabledDays(periodoFiscal, exp(expDay.add(1, 'days')));
  }
  if ((expDay).isSame(lastDay, 'day') && isTwoDaysLastMonth) {
    fechaVencimiento = await disabledDays(periodoFiscal, exp(expDay.add(1, 'month')));
  }
  if ((expDay).isAfter(lastState)) {
    fechaVencimiento = await disabledDays(periodoFiscal, exp(expDay));
  }
  if (expDay.isBefore(lastState) && isBeforeExpiryDay) {
    fechaVencimiento = await disabledDays(periodoFiscal, exp(toMoment(new Date()).set('date', day)));
  }
  if (expDay.isBefore(lastState) && !isBeforeExpiryDay) {
    if (lastState.get('date') <= day) {
      fechaVencimiento = await disabledDays(periodoFiscal, exp(lastState));
    } else if (lastDay.isSame(lastState, 'day')) {
      fechaVencimiento = await disabledDays(periodoFiscal, exp(lastDay.add(1, 'days')));
    } else {
      fechaVencimiento = await disabledDays(periodoFiscal, exp(lastDay));
    }
  }
  if (!fechaVencimiento) {
    fechaVencimiento = await disabledDays(periodoFiscal, exp(lastState.add(1, 'month').endOf('month')));
  }
  return fechaVencimiento;
};
